import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import GearService from "@services/GearService";

const ShowGear = ({ gear }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [gearData, setGearData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      GearService.find(gear.id).then((response) => {
        setGearData(response.data.data);
      });
  }, [gear.id, showModal]);

  return (
    <PermissionHandler permission={"view_gears"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={gearData.name} />
          <RowDetails label={t("nameEng")} value={gearData.name_eng} />
          <RowDetails
            label={t("matchingCodeGear")}
            value={gearData.matching_code_gear}
          />
          <RowDetails label={t("gearStd")} value={gearData.gear_std} />
          <RowDetails label={t("gearEU")} value={gearData.gear_eu_id} />
          <RowDetails
            label={t("fishingTechniqueEU")}
            value={gearData.fishing_technique_eu_id}
          />
          <RowDetails label={t("description")} value={gearData.description} />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowGear;
